var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:{'inline-block': true}},[(true)?_c('button-menu',{attrs:{"text-label":_vm.$t('project_report'),"icon":'file-excel',"active-tooltip":true,"positionTooltip":'is-left',"redirect":null,"handle-on-click":() => { _vm.generateReport() }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }